<template>
	<div class="teaser-hero">
		<Transition name="fade">
			<img
				v-if="props.item.field_hero_image?.image_style_uri?.teaser_hero_mobile"
				v-show="!hideImage"
				ref="imageRef"
				fetchpriority="high"
				decoding="async"
				:src="props.item.field_hero_image?.image_style_uri?.teaser_hero_mobile"
				:srcset="`
				${image480} 480w,
				${image768} 768w,
				${image1024} 1024w,
				${image1920} 1920w,
				${image1920} 2560w
			`"
				:alt="props.item.field_image?.meta?.alt || props.item.title"
				:class="{ 'lazy-loaded': isLoaded }"
			/>
		</Transition>

		<div class="overlay" @click="navigateToInnerPage(item.drupal_internal__nid)"></div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref, onMounted, onBeforeUnmount } from "vue"
	import router from "../../router/router"
	import { Movie } from "../../types/Movie"
	import { Series } from "../../types/Series"
	import { isLoggedIn } from "../../composables/useAuth"
	import { useLogin } from "../../composables/useLogin"
	import { useLazyImage } from "../../composables/useLazyImage"
	import { useMovieStore } from "../../stores/movies"
	import { useSeriesStore } from "../../stores/series"
	import { useUserStore } from "../../stores/user"
	import { useI18n } from "vue-i18n"
	const { locale } = useI18n()
	const userStore = useUserStore()
	const movieStore = useMovieStore()
	const seriesStore = useSeriesStore()

	const props = withDefaults(
		defineProps<{
			item: Movie | Series
			hideImage?: boolean
		}>(),
		{
			hideImage: false,
		}
	)
	const { login } = useLogin()
	const { imageRef, currentSrc, isLoaded, observe } = useLazyImage({
		rootMargin: "200px", // Load earlier for hero images
	})

	const imageSrc = computed(() => props.item.field_hero_image?.image_style_uri?.teaser_hero || "")
	const image480 = props.item.field_hero_image?.image_style_uri?.teaser_hero_mobile
	const image768 = props.item.field_hero_image?.image_style_uri?.teaser_hero_tablet
	const image1024 = props.item.field_hero_image?.image_style_uri?.teaser_hero_laptop
	const image1920 = props.item.field_hero_image?.image_style_uri?.teaser_hero
	// const image2560 = props.item.field_hero_image?.image_style_uri?.teaser_hero_2k
	const imageMedium = image1024 // fallback

	onMounted(() => {
		if (imageSrc.value) {
			observe(imageSrc.value)
		}
		// console.log("Initializing Kwik Motion Player...", props.item)
		// const container = document.getElementById(`kwik-player-${props.item.drupal_internal__nid}`)
		// if (container && !container.hasChildNodes()) {

		// }
	})

	const navigateToInnerPage = async (id) => {
		router.push({
			name: "InnerMovie",
			params: {
				id: id,
			},
		})
	}
</script>

<style scoped lang="scss">
	.teaser-hero {
		cursor: pointer;
		position: relative;
		& > img {
			width: 100%;
			object-fit: cover;
			object-position: center;
			height: 100%;
			// height: 75vh;
		}
	}

	.overlay {
		display: flex;
		flex-direction: column;
		justify-content: end;
		padding: 45px 0 45px 0;
		background: linear-gradient(0deg, var(--black) 50%, transparent 100%);

		@include br.respond-to(br.$tablet-medium) {
			padding: 15px 0 45px 0;
		}
	}

	.hero-container {
		max-width: 1780px;
		width: 100%;
		margin: 0 auto;
		padding: 0 20px;

		@include br.respond-to(1820px) {
			padding: 0;
		}
		@include br.respond-to(br.$laptop-large) {
			max-width: 1440px;
			padding: 0 30px;
		}
	}

	.main-container {
		position: absolute;
		bottom: 280px;
		left: 60px;
	}
</style>

<style lang="scss">
	.teaser-hero {
		// border-radius: 12px;
		// border-bottom-left-radius: 12px;
		// border-bottom-right-radius: 12px;
		overflow: hidden;
		.splide__track {
			padding: 0 !important;
		}
	}
</style>
